import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { deleteEntity, fetchResource, loadEntities, showErrorMessage, updateEntity } from 'helpers/utilHelpers';

import {
  CREATE_COMMENT,
  DELETE_COMMENT,
  UPDATE_COMMENT,
  SEND_EMOJI,
  MIGRATE_COMMENT,
  LOAD_TASK_COMMENTS,
} from 'constants/ActionTypes';

import {
  createCommentError,
  createCommentSuccess,
  updateCommentError,
  updateCommentSuccess,
} from 'actions/entities/commentActions';

function* loadTaskComments() {
  yield takeEvery(LOAD_TASK_COMMENTS, loadEntities);
}

function* createComment() {
  yield takeEvery(CREATE_COMMENT, fetchCommentCreate);
}

function* updateComment() {
  yield takeEvery(UPDATE_COMMENT, fetchCommentUpdate);
}

function* deleteComment() {
  yield takeEvery(DELETE_COMMENT, deleteEntity);
}

function* sendEmoji() {
  yield takeEvery(SEND_EMOJI, fetchSendEmoji);
}

function* migrateComment() {
  yield takeEvery(MIGRATE_COMMENT, updateEntity);
}

function* fetchSendEmoji(action) {
  try {
    const response = yield call(() =>
      fetchResource('comments/' + action.payload.commentId + '/react', 'PUT', action.payload.values, null, {
        expand: 'privacyUsers',
      }),
    );
    yield put(action.payload.onSuccess(response));
  } catch (e) {
    yield showErrorMessage(action.payload.onErrorMessage);
  }
}

function* fetchCommentUpdate(action) {
  const onLoading = action.payload.onLoading;
  if (onLoading) {
    onLoading(true);
  }

  try {
    const response = yield call(() =>
      fetchResource('comments/' + action.commentId, 'PUT', action.values, null, { expand: 'privacyUsers' }),
    );
    if (action.payload.onSuccessFunction) {
      action.payload.onSuccessFunction(response, action);
    }
    yield put(updateCommentSuccess(response));
  } catch (e) {
    yield put(updateCommentError(e));
  } finally {
    if (onLoading) {
      onLoading(false);
    }
  }
}

function* fetchCommentCreate(action) {
  const onLoading = action.payload.onLoading;
  if (onLoading) {
    onLoading(true);
  }

  try {
    const response = yield call(() =>
      fetchResource('comments', 'POST', action.values, null, { expand: ['privacyUsers', 'activityLog'] }),
    );
    if (action.payload.onSuccessFunction) {
      action.payload.onSuccessFunction(response, action);
    }
    yield put(createCommentSuccess(response));
  } catch (e) {
    if (e.status === 422) {
      const data = yield e.json();
      if (data['limit'] && data['limit']['message']) {
        showErrorMessage(data['limit']['message']);
      }
    }

    yield put(createCommentError(e));
  } finally {
    if (onLoading) {
      onLoading(false);
    }
  }
}

export default function* rootSaga() {
  yield all([
    fork(createComment),
    fork(updateComment),
    fork(deleteComment),
    fork(sendEmoji),
    fork(migrateComment),
    fork(loadTaskComments),
  ]);
}
